export default [
  {
    key: 'increasement',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'name',
    label: 'field.name',
    stickyColumn: true,
    variant: 'light',
    tdClass: 'limit-size',
  },
  {
    key: 'username',
    label: 'field.username',
  },
  {
    key: 'turnover',
    label: 'field.turnover',
    tdClass: 'text-right',
  },
  {
    key: 'netWl',
    label: 'field.netWinLoss',
    tdClass: 'text-right',
  },
  {
    key: 'commission',
    label: 'field.commission',
    tdClass: 'text-right',
  },
  {
    key: 'newWl',
    label: 'field.newWinLoss',
    tdClass: 'text-right',
  },
  {
    key: 'deposit',
    label: 'field.deposit',
    tdClass: 'text-right',
  },
  {
    key: 'withdrawal',
    label: 'field.withdraw',
    tdClass: 'text-right',
  },
  {
    key: 'balance',
    label: 'field.avaliableCredit',
    tdClass: 'text-right text-brand',
  },
  {
    key: 'member',
    label: 'field.member',
    tdClass: 'text-center',
  },
  {
    key: 'outstanding',
    label: 'field.outstanding',
    tdClass: 'text-center',
  },
  {
    key: 'status',
    label: 'field.status',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
];
